import { useTranslation } from "react-i18next";
import {
  GreenTimer,
  HalfEyeIcon,
  InfoTooltip,
  NewHistoryIcon,
  RedTimer,
  ReverseArrows,
  SettingIcon,
  TrashRedIcon,
  YellowTimer,
} from "../../../styled/AllImages";
import TooltipInfo from "../../tooltip/InfoTooltip";
import ProfileTooltip from "../../tooltip/ProfileTooltip";
import { usePermission } from "../../../../context/permissionsContext";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import CabinetsApi from "../../../../services/api/cabinetsApi";
import { toast } from "react-toastify";
import { useUser } from "../../../../context/userContext";

const ActionButtons = ({
  row,
  onEdit,
  onDelete,
  onOpen,
  onViewDetails,
  onStatusToggle,
  status,
  options,
  onInfoView,
  onTransfer,
  tooltipData,
  department,
  typeId,
  updateVisibilityStatus,
  onVisibility,
}) => {
  const { t } = useTranslation();
  const {user} = useUser();
  const { getModuleOperations } = usePermission();
  const departmentInfo = department ? department.department_info : [];
  const cabinetTypeId = typeId == 1 ? 2 : typeId == 2 ? 3 : typeId;

  console.log("cabinetTypeId: ", cabinetTypeId);
  
  const now = new Date();
  const targetTime = row?.time_limit_start ? new Date(row?.time_limit_start) : new Date();
  const isTempCabinActive = !row?.is_temporary || (row?.is_temporary && now >= targetTime);
  
  const filteredOptions =
    parseInt(user?.id) !== parseInt(row?.owner_user?.id)
      ? options.filter((option) => option !== "expiry")
      : options;

  return (
    <div className="action-buttons">
      {filteredOptions?.includes("expiry")
        ? (() => {
            const expiryIcons = { 0: YellowTimer, 1: GreenTimer, 2: RedTimer };
            const visibility = parseInt(row?.visibility_for_temp);
            const Icon = expiryIcons[visibility];

            return (
              <span
                data-tooltip-id={Icon ? "action-tooltip" : undefined}
                data-tooltip-content={Icon ? t("visibility") : undefined}
                style={{
                  width: "38px",
                  height: "38px",
                  display: "inline-block",
                }}
              >
                {Icon ? (
                  <Icon {...(visibility !== 2 && {onClick: onVisibility})} style={{ cursor: "pointer" }} />
                ) : null}
              </span>
            );
          })()
        : null}
      {filteredOptions &&
        filteredOptions.includes("open") &&
        getModuleOperations(cabinetTypeId, 3) && (
          <button
            data-tooltip-id="action-tooltip"
            data-tooltip-content={t("open")}
            onClick={onOpen}
          >
            {t("open")}
          </button>
        )}

      {filteredOptions && filteredOptions.includes("tooltip") && (
        <TooltipInfo data={tooltipData} />
      )}

      {filteredOptions && filteredOptions.includes("tooltip2") && department && (
        <ProfileTooltip
          data={departmentInfo}
          userName={department.userName}
          userRole={department.userRole}
          userImage={department.userImage}
        />
      )}

      {filteredOptions &&
        filteredOptions.includes("view") &&
        getModuleOperations(typeId, 3) && (
          <span
            className="default-icon"
            data-tooltip-id="action-tooltip"
            data-tooltip-content={t("view_details")}
            onClick={() => onViewDetails(row)}
          >
            <HalfEyeIcon />
          </span>
        )}

      {filteredOptions &&
        filteredOptions.includes("info") &&
        getModuleOperations(typeId, 5, 1) && (
          <span
            className="default-icon"
            data-tooltip-id="action-tooltip"
            data-tooltip-content={t("access_log")}
            onClick={() => onInfoView(row)}
          >
            <NewHistoryIcon />
          </span>
        )}

      {filteredOptions &&
        filteredOptions.includes("edit") &&
        getModuleOperations(typeId, 4) && (
          <span
            onClick={() => onEdit(row)}
            className="default-icon"
            data-tooltip-id="action-tooltip"
            data-tooltip-content={t("edit")}
          >
            <SettingIcon />
          </span>
        )}

      {filteredOptions && filteredOptions.includes("transfer") && (
        <span
          className="default-icon"
          onClick={onTransfer}
          data-tooltip-id="action-tooltip"
          data-tooltip-content={t("transfer")}
        >
          <ReverseArrows />
        </span>
      )}

      {filteredOptions &&
        filteredOptions.includes("status") &&
        getModuleOperations(typeId, 4) && (
          <div
            className={`switch ${parseInt(status) === 1 ? "active" : ""}`}
            onClick={onStatusToggle}
            data-tooltip-id="action-tooltip"
            data-tooltip-content={t("status")}
          >
            <span className="slider" />
          </div>
        )}

      {filteredOptions && filteredOptions.includes("delete") && (
        <span
          onClick={onDelete}
          className="default-icon"
          data-tooltip-id="action-tooltip"
          data-tooltip-content={t("delete")}
        >
          <TrashRedIcon />
        </span>
      )}
      <Tooltip
        id="action-tooltip"
        place="top"
        style={{
          backgroundColor: "#333",
          color: "#fff",
          fontSize: "12px",
          borderRadius: "6px",
          padding: "6px 10px",
        }}
      />
    </div>
  );
};

export default ActionButtons;
